import type { MouseEvent } from 'react';
import { Text, UnstyledButton } from '@mantine/core';
import { useCanChooseDefaultTemplate } from 'src/data-capture/hooks/templates/useCanChooseDefaultTemplate';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './MakeDefaultAction.module.css';

/**
 * The "Make default" control on a template row, shown to people who can choose the firm's default
 * while the row is hovered.
 * The row it sits in carries `data-make-default-row`, or is a `SearchableMenu` option.
 */
export function MakeDefaultAction({ onClick }: { onClick: () => void }) {
  const canChooseDefault = useCanChooseDefaultTemplate();
  if (!canChooseDefault) return null;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    // Rows treat a prevented click as handled, so this opens the confirmation without also
    // selecting the row. Letting the click carry on (rather than stopping it) lets a menu close.
    event.preventDefault();
    onClick();
  };

  return (
    <UnstyledButton className={classes.action} onClick={handleClick}>
      <Text span size="sm" fw={FONT_WEIGHTS.semibold} c="brand.6">
        Make default
      </Text>
    </UnstyledButton>
  );
}
